import { Flex } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useUser } from 'src/context/userContext'
import { renderBrowser } from '../../helpers/renderBrowser'
import { useWindowSize } from '../../hooks/useWindowSize'
import MobileSuccess from '../onboard/Success/MobileSuccess'
import EdgecasesLandingPage from './EdgecasesLandingPage'
import SafariLandingPage from './SafariLandingPage'
import Supported from './Supported'

const MOBILE_SIZE_LIMIT = 1024

const ExtensionLandingPage: React.FC = () => {
  const { width } = useWindowSize()
  const inMobile = width && width <= MOBILE_SIZE_LIMIT
  const { user } = useUser()
  const [currentBrowser, setCurrentBrowser] = useState('')

  useEffect(() => {
    setCurrentBrowser(renderBrowser())
    if (!user) return
  }, [user])

  const renderBrowserExtension = () => {
    if (!inMobile) {
      if (currentBrowser === 'Supported') {
        return <Supported />
      } else if (currentBrowser === 'Safari') {
        return <SafariLandingPage />
      } else {
        return <EdgecasesLandingPage />
      }
    } else {
      return <MobileSuccess />
    }
  }

  return (
    <Flex
      flexDirection='column'
      bg='white'
      justifyContent='center'
      alignItems='center'
      marginBottom='50px'
      paddingTop='15px'
    >
      {renderBrowserExtension()}
    </Flex>
  )
}

export default ExtensionLandingPage
